export default {
  primaryBorderShadow: '0 3px 10px 0 rgba(0, 130, 189, 0.2)',
  secondaryBorderShadow: '0 3px 15px 0 rgba(49, 175, 107, 0.2)',
};
